"use strict";

exports.__esModule = true;
exports.getLowerCaseText = void 0;
var getLowerCaseText = exports.getLowerCaseText = function getLowerCaseText(text) {
  try {
    return text.toLowerCase();
  } catch (_) {
    return text;
  }
};